/**
 * UI initialization and counters for FilterController
 */

// Initialize filter UI components
export function initializeUI(ctx, config) {
	window.prev_sel = undefined;
	const trees = ctx.trees; // keep for callbacks
	window.trees = ctx.trees; // global for compatibility
	for (const [k, cat] of Object.entries(ctx.filters)) {
		
		// Skip mgGroups - it's not a filter category, it's metadata for expanding selections
		if (k === 'mgGroups') {
			continue;
		}
		
		// Skip filter creation if no options or only empty values
		// Check if cat is an array before calling .every()
		if (!cat || !Array.isArray(cat) || cat.length === 0 || cat.every(c => c === 'empty')) {
			// Remove existing filter container if it exists
			const existingFilt = $(`.filter-${k}`);
			if (existingFilt.length > 0) {
				existingFilt.remove();
			}
			continue;
		}
		
		let filt = $(`.filter-${k}`);
		if (filt.length === 0) {
			filt = $(`<div class="filter flex-grow-1 mb-0 filter-${k}"></div>`);
			filt.insertBefore($(ctx.filterElements.dateContainer));
		}
		let opts = [];
		
		// For M group, create hierarchical structure from mgGroups if available
		if (k === 'M' && ctx.filters && ctx.filters.mgGroups && Object.keys(ctx.filters.mgGroups).length > 0) {
			
			// Collect all M values that belong to MG groups
			const mValuesInGroups = new Set();
			for (const mValues of Object.values(ctx.filters.mgGroups)) {
				if (Array.isArray(mValues)) {
					mValues.forEach(m => mValuesInGroups.add(m));
				}
			}
			
			// Process MG groups and create hierarchical structure
			for (const [mg, mValues] of Object.entries(ctx.filters.mgGroups)) {
				if (!Array.isArray(mValues) || mValues.length === 0) continue;
				
				// For 'empty' MG group, add M values as flat items
				if (mg === 'empty') {
					// Sort by filterOrder['M'] if available
					let sortedEmptyValues = mValues.filter(mVal => mVal !== 'empty');
					if (ctx.filterOrder && ctx.filterOrder['M'] && Array.isArray(ctx.filterOrder['M'])) {
						const orderMap = new Map();
						ctx.filterOrder['M'].forEach((val, idx) => {
							orderMap.set(val, idx);
						});
						sortedEmptyValues.sort((a, b) => {
							const orderA = orderMap.has(a) ? orderMap.get(a) : 9999;
							const orderB = orderMap.has(b) ? orderMap.get(b) : 9999;
							return orderA - orderB;
						});
					}
					
					const emptyGroupValues = sortedEmptyValues
						.map(mVal => {
							let translation = mVal;
							try {
								if (config.translations && config.translations[mVal] && config.translations[mVal][config.language]) {
									translation = config.translations[mVal][config.language];
								}
							} catch (e) {
								translation = mVal;
							}
							return { name: translation, value: mVal, children: [] };
						});
					opts.push(...emptyGroupValues);
					continue;
				}
				
				// For non-empty MG groups, create hierarchical structure
				let mgTranslation = mg;
				try {
					if (config.translations && config.translations[mg] && config.translations[mg][config.language]) {
						mgTranslation = config.translations[mg][config.language];
					}
				} catch (e) {
					mgTranslation = mg;
				}
				
				const children = mValues
					.filter(mVal => mVal !== 'empty')
					.map(mVal => {
						let translation = mVal;
						try {
							if (config.translations && config.translations[mVal] && config.translations[mVal][config.language]) {
								translation = config.translations[mVal][config.language];
							}
						} catch (e) {
							translation = mVal;
						}
						return { name: translation, value: mVal, children: [] };
					});
				
				// Sort children by filterOrder['M'] if available
				if (ctx.filterOrder && ctx.filterOrder['M'] && Array.isArray(ctx.filterOrder['M'])) {
					const orderMap = new Map();
					ctx.filterOrder['M'].forEach((val, idx) => {
						orderMap.set(val, idx);
					});
					children.sort((a, b) => {
						const orderA = orderMap.has(a.value) ? orderMap.get(a.value) : 9999;
						const orderB = orderMap.has(b.value) ? orderMap.get(b.value) : 9999;
						return orderA - orderB;
					});
				}
				
				if (children.length > 0) {
					opts.push({
						name: mgTranslation,
						value: mg,
						isGroupSelectable: false,
						children: children
					});
				}
			}
			
			// Add M values that are NOT in any MG group as flat items
			// Use sorted order from ctx.filters['M'] if available
			const sortedMValues = ctx.filters && ctx.filters['M'] ? ctx.filters['M'] : cat;
			for (let c in sortedMValues) {
				if (sortedMValues[c] === 'empty') continue;
				if (!mValuesInGroups.has(sortedMValues[c])) {
					let translation;
					try {
						if (config.translations && config.translations[sortedMValues[c]] && config.translations[sortedMValues[c]][config.language]) {
							translation = config.translations[sortedMValues[c]][config.language];
						} else {
							translation = sortedMValues[c];
						}
					} catch (e) {
						translation = sortedMValues[c];
					}
					opts.push({ name: translation, value: sortedMValues[c], children: [] });
				}
			}
			
			// Sort options according to filterOrder['M'] if available
			if (ctx.filterOrder && ctx.filterOrder['M'] && Array.isArray(ctx.filterOrder['M'])) {
				const orderMap = new Map();
				ctx.filterOrder['M'].forEach((val, idx) => {
					orderMap.set(val, idx);
				});
				
				// Sort function: get order index for option value
				const getOrderIndex = (opt) => {
					if (opt.children && opt.children.length > 0) {
						// For MG groups, use first child's order
						const firstChild = opt.children[0];
						return orderMap.has(firstChild.value) ? orderMap.get(firstChild.value) : 9999;
					}
					return orderMap.has(opt.value) ? orderMap.get(opt.value) : 9999;
				};
				
				opts.sort((a, b) => {
					const orderA = getOrderIndex(a);
					const orderB = getOrderIndex(b);
					return orderA - orderB;
				});
				
				// Also sort children within each MG group
				opts.forEach(opt => {
					if (opt.children && opt.children.length > 0) {
						opt.children.sort((a, b) => {
							const orderA = orderMap.has(a.value) ? orderMap.get(a.value) : 9999;
							const orderB = orderMap.has(b.value) ? orderMap.get(b.value) : 9999;
							return orderA - orderB;
						});
					}
				});
			}
		} else {
			// For other groups, create flat structure
		for (let c in cat) {
			// Skip 'empty' values
			if (cat[c] === 'empty') continue;
			
			let translation;
			try {
				if (config.translations && config.translations[cat[c]] && config.translations[cat[c]][config.language]) {
					translation = config.translations[cat[c]][config.language];
				} else { translation = cat[c]; }
			} catch (e) { console.error(`[FilterController] Translation error for ${cat[c]}:`, e); translation = cat[c]; }
			opts.push({ name: translation, value: cat[c], children: [] });
			}
		}
		
		// Skip if no valid options after filtering
		if (opts.length === 0) {
			if (debugMode === '1') { console.log(`[FilterController] Skipping filter ${k} - no valid options after filtering`); }
			// Remove filter container
			filt.remove();
			continue;
		}
		
        ctx.trees[k] = new Treeselect({
			direction: 'bottom',
			clearable: false,
            searchable: false,
			parentHtmlContainer: filt[0],
			value: config.startCategories[k] || [],
			placeholder: (config.translations && config.translations[k] && config.translations[k][config.language]) ? config.translations[k][config.language] : k,
			options: opts,
            // Keep dropdown open after selection to allow multi-pick
            closeOnSelect: false,
            // Allow multiple values per group
            multiple: true,
			nameChangeCallback: function(sel) {},
			inputCallback: function(sel) {
				// Skip callback during initialization if values are from config (will be applied later)
				// Only handle user-initiated changes during initialization
				if (ctx.isInitializing) {
					// During init, values are set from config.startCategories, don't process them here
					// They will be processed in the setTimeout block after all trees are mounted
					return;
				}
				ctx.handleFilterChange(k, sel);
				let filters_counter = 0;
				$.each(trees, function(key, value) { filters_counter += trees[key].allValue.length; });
				$('.fnd-filter-counter').text(filters_counter > 0 ? filters_counter : "");
				// Note: applyFilters is already called in handleFilterChange, no need to call it again here
			},
			openCallback: function() {
				// Activate hover mode when dropdown opens via click
				if (!ctx.hoverModeActive) {
					ctx.hoverModeActive = true;
				}
				
				// Close all other open dropdowns when this one opens
				for (const [otherKey, otherTree] of Object.entries(ctx.trees)) {
					if (otherKey !== k && otherTree && otherTree.srcElement) {
						// Check if dropdown is open by CSS class (treeselect-input--opened)
						const inputElement = otherTree.srcElement.querySelector('.treeselect-input');
						if (inputElement && inputElement.classList.contains('treeselect-input--opened')) {
							// Use public API method to close
							if (typeof otherTree.toggleOpenClose === 'function') {
								otherTree.toggleOpenClose();
							}
						}
					}
				}
			},
			closeCallback: function() {
				// Deactivate hover mode if all dropdowns are closed
				let anyOpen = false;
				for (const [otherKey, otherTree] of Object.entries(ctx.trees)) {
					if (otherTree && otherTree.srcElement) {
						const inputElement = otherTree.srcElement.querySelector('.treeselect-input');
						if (inputElement && inputElement.classList.contains('treeselect-input--opened')) {
							anyOpen = true;
							break;
						}
					}
				}
				if (!anyOpen) {
					ctx.hoverModeActive = false;
				}
			}
		});
		ctx.trees[k].mount();
		// Set data-key and data-label immediately after mount
		const setDataAttributes = () => {
			const treeselectInput = filt.find('.treeselect-input')[0];
			if (treeselectInput) {
				treeselectInput.setAttribute('data-key', k);
				// Set translated label for background text
				const label = (config.translations && config.translations[k] && config.translations[k][config.language]) 
					? config.translations[k][config.language] 
					: k;
				treeselectInput.setAttribute('data-label', label.toUpperCase());
			} else {
				// Retry if element not ready yet
				setTimeout(setDataAttributes, 50);
			}
		};
		setTimeout(setDataAttributes, 100);
		setTimeout(() => {
			const container = filt[0];
			const inputElement = container.querySelector('.treeselect-input');
			if (inputElement) {
				inputElement.addEventListener('click', (e) => { if (debugMode === '1') { console.log(`[FilterController] Clicked on ${k} input:`, e); } });
			} else {
				if (debugMode === '1') { console.error(`[FilterController] No input element found for ${k}`); }
			}
			const listItems = container.querySelectorAll('.treeselect-list__item');
			listItems.forEach((item, index) => { item.addEventListener('click', (e) => { if (debugMode === '1') { console.log(`[FilterController] Clicked on ${k} item ${index}:`, item.textContent); } }); });
		}, 100);
	}
	// Apply startCategories to trigger filters - pass full array, not just first element
	// Use setTimeout to ensure Treeselect is fully mounted and DOM is ready
	setTimeout(() => {
		for (const [k, cat] of Object.entries(config.startCategories)) { 
			if (cat && Array.isArray(cat) && cat.length > 0 && ctx.trees[k]) {
				// Check if values are already set (from constructor value parameter)
				const currentValue = ctx.trees[k].allValue || ctx.trees[k].value || [];
				const needsUpdate = currentValue.length !== cat.length || 
					!cat.every(val => currentValue.includes(val));
				
				if (needsUpdate) {
					// IMPORTANT: Update Treeselect UI first to ensure values are set
					if (typeof ctx.trees[k].updateValue === 'function') {
						ctx.trees[k].updateValue(cat);
					} else if (ctx.trees[k].allValue !== undefined) {
						// Fallback: manually set allValue if updateValue doesn't exist
						ctx.trees[k].allValue = [...cat];
						// Trigger render if needed
						if (ctx.trees[k].mount) {
							ctx.trees[k].mount();
						}
					}
				}
				// Always trigger filter change to ensure filters are applied
				ctx.handleFilterChange(k, cat);
			} 
		}
		ctx.updateFilterCounter();
	}, 200);
	
	// Initial availability computation
	try {
		if (typeof window.computeAvailability === 'function') {
			const avail = window.computeAvailability(ctx);
			applyAvailability(ctx, avail);
		}
	} catch(_) {}
	setTimeout(() => {
		['L', 'F', 'M', 'S'].forEach(k => {
			const container = $(`.filter-${k}`);
			if (container.length) {
				const input = container.find('.treeselect-input')[0];
				if (input) {
					if (!input.getAttribute('data-key')) {
						input.setAttribute('data-key', k);
					}
					// Always set/update translated label for background text
					const label = (config.translations && config.translations[k] && config.translations[k][config.language]) 
						? config.translations[k][config.language] 
						: k;
					input.setAttribute('data-label', label.toUpperCase());
				}
			}
		});
	}, 500);

	// Setup global click handler to close all dropdowns when clicking outside
	setupOutsideClickHandler(ctx);
	
	// Setup hover mode for treeselect inputs
	setupHoverMode(ctx);
}

// Setup click outside handler to close all open dropdowns
export function setupOutsideClickHandler(ctx) {
	// Remove previous handler if exists
	$(document).off('click.treeselectOutside');

	// Add new handler
	$(document).on('click.treeselectOutside', function(e) {
		// Check if click was inside any treeselect container or dropdown list
		const $target = $(e.target);
		const isInsideTreeselect = $target.closest('.filter-L, .filter-F, .filter-M, .filter-S, .treeselect, .treeselect-input, .treeselect-list').length > 0;

		// If click was outside all treeselects, close all open dropdowns and deactivate hover mode
		if (!isInsideTreeselect) {
			ctx.hoverModeActive = false;
			for (const [key, tree] of Object.entries(ctx.trees)) {
				if (tree && tree.srcElement) {
					const inputElement = tree.srcElement.querySelector('.treeselect-input');
					if (inputElement && inputElement.classList.contains('treeselect-input--opened')) {
						if (typeof tree.toggleOpenClose === 'function') {
							tree.toggleOpenClose();
						}
					}
				}
			}
		}
	});
}

// Setup hover mode: after first click, hover on other treeselect-inputs opens them automatically
export function setupHoverMode(ctx) {
	// Initialize hover mode flag if not exists
	if (ctx.hoverModeActive === undefined) {
		ctx.hoverModeActive = false;
	}
	
	// Remove previous handlers if exist
	$(document).off('mouseenter.treeselectHover', '.treeselect-input');
	
	// Add hover handler to all treeselect-inputs
	$(document).on('mouseenter.treeselectHover', '.treeselect-input', function(e) {
		// Only work in hover mode (activated after first click)
		if (!ctx.hoverModeActive) {
			return;
		}
		
		const $target = $(e.currentTarget);
		const dataKey = $target.attr('data-key');
		
		// Find the corresponding tree instance
		if (!dataKey || !ctx.trees[dataKey]) {
			return;
		}
		
		const tree = ctx.trees[dataKey];
		const inputElement = tree.srcElement?.querySelector('.treeselect-input');
		
		// Skip if this dropdown is already open
		if (inputElement && inputElement.classList.contains('treeselect-input--opened')) {
			return;
		}
		
		// Close all other open dropdowns
		for (const [otherKey, otherTree] of Object.entries(ctx.trees)) {
			if (otherKey !== dataKey && otherTree && otherTree.srcElement) {
				const otherInputElement = otherTree.srcElement.querySelector('.treeselect-input');
				if (otherInputElement && otherInputElement.classList.contains('treeselect-input--opened')) {
					if (typeof otherTree.toggleOpenClose === 'function') {
						otherTree.toggleOpenClose();
					}
				}
			}
		}
		
		// Open this dropdown
		if (typeof tree.toggleOpenClose === 'function') {
			tree.toggleOpenClose();
		}
	});
}

// Update filter counter display
export function updateFilterCounter(ctx) {
	let count = 0;
	const treeCounts = {};
	$.each(ctx.trees, (key, tree) => {
		if (tree && tree.allValue) {
			count += tree.allValue.length;
			if (tree.allValue.length) treeCounts[key] = tree.allValue.slice(0, 5);
		}
	});
	if (ctx.activeFilters.dateFrom) count++;
	if (ctx.activeFilters.dateTo) count++;
	// Diagnostic breakdown for the "phantom badge" bug (badge shows N on a seemingly
	// clean load): always exposed on window, printed with ?debug=1.
	window.__badgeDebug = {
		count: count,
		trees: treeCounts,
		dateFrom: ctx.activeFilters.dateFrom || '',
		dateTo: ctx.activeFilters.dateTo || '',
		at: new Date().toISOString()
	};
	if (window.debugMode === '1' && count > 0) {
		console.log('[FilterCounter] breakdown:', JSON.stringify(window.__badgeDebug));
	}
	const countText = count > 0 ? count : "";
	$(ctx.filterElements.counter).text(countText);
	
	// Hide counter badge if no filters are active
	if (ctx.filterElements.counter) {
		const $counter = $(ctx.filterElements.counter);
		if (count === 0) {
			$counter.hide();
		} else {
			$counter.show();
		}
	}
	
	// Update desktop filter toggle badge (when filters are collapsed)
	const desktopCounter = document.querySelector('.fnd-filter-counter-desktop');
	if (desktopCounter) {
		// Get actual filters div state FIRST
		const filtersDiv = document.getElementById('filters-div');
		const isCollapsed = filtersDiv && !filtersDiv.classList.contains('show');
		
		// CRITICAL LOGIC: Badge shows ONLY when: filters collapsed AND count > 0
		// Hide in ALL other cases:
		// 1. No filters (count === 0)
		// 2. Filters expanded (!isCollapsed)
		// 3. Empty count text (!countText)
		if (count === 0 || !countText || !isCollapsed) {
			desktopCounter.textContent = '';
			desktopCounter.style.display = 'none';
			desktopCounter.style.visibility = 'hidden';
			desktopCounter.classList.add('d-none');
			return;
		}
		
		// Show badge ONLY when: filters are collapsed AND there are active filters
		if (isCollapsed && count > 0) {
			desktopCounter.textContent = countText;
			desktopCounter.style.display = 'block';
			desktopCounter.style.visibility = 'visible';
			desktopCounter.classList.remove('d-none');
		} else {
			desktopCounter.textContent = '';
			desktopCounter.style.display = 'none';
			desktopCounter.style.visibility = 'hidden';
			desktopCounter.classList.add('d-none');
		}
	}
	// Counter update logging only in debug mode
}

// Clear all filters and reset UI
export function clearAllFilters(ctx) {
	try {
		$.each(ctx.trees, (i, tree) => {
			tree.updateValue([]);
			for (let j in tree.options) { tree.options[j].disabled = false; }
			
			// Save label before mount to restore after
			const label = (ctx.translations && ctx.translations[i] && ctx.translations[i][ctx.language]) 
				? ctx.translations[i][ctx.language] 
				: i;
			const labelUpper = label.toUpperCase();
			
			tree.mount();
			
			// Restore data-label after mount (element might be recreated)
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					const filterContainer = $(`.filter-${i}`);
					if (filterContainer.length) {
						const treeselectInput = filterContainer.find('.treeselect-input')[0];
						if (treeselectInput) {
							treeselectInput.setAttribute('data-label', labelUpper);
						}
					}
				});
			});
		});
		$(ctx.filterElements.dateInputs).val("");
		// Preserve searchQuery when clearing filters - only clear categories and dates
		const currentSearchQuery = ctx.activeFilters.searchQuery || '';
		ctx.activeFilters = { categories: {}, dateFrom: '', dateTo: '', searchQuery: currentSearchQuery };
		// Sync preserved search query back to search input
		if (window.filterManager && window.filterManager.filterElements && window.filterManager.filterElements.searchInput) {
			window.filterManager.filterElements.searchInput.value = currentSearchQuery;
		}
		// Apply filters without URL update first
		if (window.filterManager && typeof window.filterManager.applyFilters === 'function') { window.filterManager.applyFilters(false); }
		$(ctx.filterElements.counter).text("");
		if (debugMode === '1') { console.log(`[FilterController] Clearing filters, updating search`); }
		if (typeof window.search_categories !== 'undefined') { window.search_categories = []; if (debugMode === '1') { console.log(`[FilterController] Cleared global search_categories`); } }
		// Update URL immediately after clearing filters to remove category parameters
		if (typeof ctx.updateUrlWithFilters === 'function') { 
			ctx.updateUrlWithFilters(true); // true = immediate update
		}
	} catch (error) {
		if (debugMode === '1') { console.error('[FilterController] Error clearing filters:', error); }
	}
}

// Apply availability map to treeselect options: disable options not present in availability
export function applyAvailability(ctx, availabilityByGroup) {
    try {
        if (!availabilityByGroup || typeof availabilityByGroup !== 'object') return;
        for (const [group, tree] of Object.entries(ctx.trees)) {
            const enabled = availabilityByGroup[group] || new Set();
            const opts = tree.options || [];
            let changed = false;
            
            // Recursively set disabled state for all options (including children)
            const setDisabled = (optsList) => {
                for (const opt of optsList) {
                    let shouldEnable = enabled.has(opt.value);
                    
                    // For MG parent groups: check if ANY child is enabled
                    if (opt.children && opt.children.length > 0) {
                        const hasEnabledChild = opt.children.some(child => enabled.has(child.value));
                        shouldEnable = hasEnabledChild; // MG enabled if ANY child is enabled
                        // Recursively set disabled for children first
                        setDisabled(opt.children);
                    }
                    
                    const oldDisabled = !!opt.disabled;
                    opt.disabled = !shouldEnable;
                    if (oldDisabled !== opt.disabled) changed = true;
                }
            };
            setDisabled(opts);
            
            if (changed) {
                // Update options in Treeselect by calling mount() with saved value
                const savedValue = tree.allValue || [];
                if (tree.mount) {
                    // Save label before mount to restore it immediately after
                    const label = (ctx.translations && ctx.translations[group] && ctx.translations[group][ctx.language]) 
                        ? ctx.translations[group][ctx.language] 
                        : group;
                    const labelUpper = label.toUpperCase();
                    
                    tree.mount();
                    
                    // Restore data-label after mount (use double RAF to ensure DOM is updated)
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            const filterContainer = $(`.filter-${group}`);
                            if (filterContainer.length) {
                                const treeselectInput = filterContainer.find('.treeselect-input')[0];
                                if (treeselectInput) {
                                    treeselectInput.setAttribute('data-label', labelUpper);
                                }
                            }
                        });
                    });
                    
                    // Restore selection after mount
                    if (savedValue.length > 0 && tree.updateValue) {
                        setTimeout(() => {
                            tree.updateValue(savedValue);
                        }, 0);
                    }
                }
            }
        }
    } catch (e) {
        if (debugMode === '1') { console.error('[FilterController] applyAvailability error', e); }
    }
}


